import './card-component.scss';
import { ReactNode } from 'react';

interface Props {
  header: ReactNode;
  body: ReactNode;
  footer?: ReactNode;
}

const CardComponent = ({ header, body, footer }: Props) => {
  return (
    <div className="card-component">
      <div>{header}</div>
      <div>{body}</div>
      {footer && <div>{footer}</div>}
    </div>
  );
};
export default CardComponent;
